// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","194":"a6f208e3","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"3ac7cfa8c00daadf186e","194":"20b165c3fe011f9928b9","293":"9f884d6e04cc624092a0"}[chunkId] + ".js";
};